import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes } from '../../themes/styles';

export interface IInfoStyles {
  root: IStyle;
  icon: IStyle;
  text: IStyle;
}

export const infoStylesDefault = (theme: IH2OTheme): Partial<IInfoStyles> => ({
  root: {
    position: 'relative',
    display: 'flex',
    '&.is-tooltip': {
      display: 'inline-block',
    },
  },
  icon: {
    paddingTop: 3,
  },
  text: {
    paddingLeft: 7,
    lineHeight: 14,
    fontSize: FontSizes.xxxsmall,
    color: theme.semanticColors?.textQuinary,
  },
});

export const infoStylesNoSpace = {
  icon: {
    paddingTop: 0,
  },
};
